import axios from 'axios'
import { getResponseErrorMessage } from '@/store/utils'

const state = {
  stats: null,
  accountStats: null,
}

const getState = () => JSON.parse(JSON.stringify(state))

export default {
  namespaced: true,
  state: getState(),
  getters: {},
  actions: {
    initialize ({ commit, rootGetters }) {
      commit('RESET_STATE')
      commit('SET_IS_LOADING', true, { root: true })

      const accountId = rootGetters.accountId
      const request = accountId
        ? axios
          .get(`/admin/stats/account?by_account_id=${accountId}`)
          .then((response) => commit('SET_ACCOUNT_STATS', response.data))
        : axios
          .get('/admin/stats')
          .then((response) => commit('SET_STATS', response.data))

      return request
        .catch(error => {
          console.error(error)
          const errorMessage = getResponseErrorMessage(error) ?? 'Napaka pri pridobivanju statistike, prosimo poskusite kasneje.'
          commit('SET_MESSAGE', { text: errorMessage, type: 'error' }, { root: true })
        })
        .finally(() => commit('SET_IS_LOADING', false, { root: true }))
    },
    reset ({ commit }) {
      commit('RESET_STATE')
    },
  },
  mutations: {
    SET_STATS (state, stats) {
      state.stats = stats
    },
    SET_ACCOUNT_STATS (state, accountStats) {
      state.accountStats = accountStats
    },
    RESET_STATE (state) {
      Object.assign(state, getState())
    },
  },
}
